import type { ImgHTMLAttributes } from "react"

export default function AppLogoIcon(
  props: ImgHTMLAttributes<HTMLImageElement>,
) {
  return (
    <img src="/icon.png" alt="Catador Pro" width="32" height="32" {...props} />
  )
}
